import { useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Collapse, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import useAppShellSx from '../../hooks/useAppShellSx';
import useSidebarTransition from '../../hooks/useSidebarTransition';
import SidebarNavGroup from './SidebarNavGroup';

export default function SidebarSection({
  section,
  collapsed,
  pathname,
  onNavigate,
  onConceptBuilderExpand,
}) {
  const { sidebar, sidebarType } = useAppShellSx();
  const { sectionCollapseTimeout } = useSidebarTransition();
  const [sectionOpen, setSectionOpen] = useState(true);

  if (!section?.items?.length) return null;

  const hasHeading = Boolean(section.title);

  return (
    <Box sx={{ mb: hasHeading ? 2 : 1, '&:first-of-type': { mt: 0 } }}>
      {hasHeading && (
        <Collapse in={!collapsed} timeout={sectionCollapseTimeout} unmountOnExit>
          <Box
            component="button"
            type="button"
            onClick={() => setSectionOpen((prev) => !prev)}
            sx={{
              width: 'calc(100% - 32px)',
              mx: 2,
              mb: 0.5,
              border: 'none',
              bgcolor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 0,
              py: 0.75,
              cursor: 'pointer',
              color: sidebar.textSection,
            }}
          >
            <Typography sx={sidebarType.sectionLabel}>{section.title}</Typography>
            {sectionOpen ? (
              <ExpandLessIcon sx={{ fontSize: 14, color: sidebar.textSection }} />
            ) : (
              <ExpandMoreIcon sx={{ fontSize: 14, color: sidebar.textSection }} />
            )}
          </Box>
        </Collapse>
      )}

      <Collapse in={collapsed || !hasHeading || sectionOpen} timeout={sectionCollapseTimeout}>
        {section.items.map((item) => {
          if (!item) return null;
          return (
            <SidebarNavGroup
              key={item.key || item.title}
              item={item}
              collapsed={collapsed}
              pathname={pathname}
              onNavigate={onNavigate}
              onConceptBuilderExpand={onConceptBuilderExpand}
            />
          );
        })}
      </Collapse>
    </Box>
  );
}

SidebarSection.propTypes = {
  section: PropTypes.object.isRequired,
  collapsed: PropTypes.bool,
  pathname: PropTypes.string.isRequired,
  onNavigate: PropTypes.func.isRequired,
  onConceptBuilderExpand: PropTypes.func,
};
